<lgv-pricing-quotes-card-list [showLoanFilter]="false" [fromLoanApp]="true"></lgv-pricing-quotes-card-list>